<p-button icon="pi pi-user-plus" (onClick)="showDialog = true" label="Dodaj iz evidencije"></p-button>

<ng-container *ngIf="showDialog">
  <p-dialog
    [resizable]="false"
    [(visible)]="showDialog"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{width: '100vw', height: '100vh'}"
    appendTo="body"
  >
    <h2>Odaberite stranke</h2>
    <app-odabir-osobe (itemSelected)="onSelectedItem($event)"></app-odabir-osobe>
  </p-dialog>
</ng-container>
